import axios from '../../../services/axios';

function acceleratorApply(params) {
  return axios({
    method: 'POST',
    url: '/accelerator/apply/',
    params,
  });
}

const api = {
  acceleratorApply,
};

export default api;
